import React from 'react';
import { Row, Col } from 'antd';

import { Footer } from './Footer';
import { Content } from './Content';
import { Spinner } from '@/components/Spinner';
import { Refetch } from '@/components/ui/Refetch';
import { useCalculateReturnOfInvestments } from '@/context/CalculatorReturnOfInvestment';
import { useGetReturnOfInvestmentsResult } from '@/hooks';
import * as S from './styles';

export function Result() {
	const { id } = useCalculateReturnOfInvestments();

	const { isLoading, data, isError, refetch } = useGetReturnOfInvestmentsResult({
		id: id!
	});

	if (isLoading) {
		return <Spinner />;
	}

	if (isError) {
		return <Refetch onClick={refetch} />;
	}

	return (
		<Row gutter={[24, 24]}>
			<Col span={24}>
				<S.Container>
					<Content percentage={data.percentage_economy} months={data.months} />
				</S.Container>
			</Col>
			<Col span={24}>
				<Footer />
			</Col>
		</Row>
	);
}
